import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navbar from './layout/Navbar';
const useAuth = () => {
    let user =  localStorage.getItem('vcust_plant_code') ;
    // console.log(user)
    if (user) {
        try {
            if ((user)) {
                return user;
            }
        } catch (error) {
            console.log("log1", error)
            return false
        }

    } else {
        console.log("log2", "test")
        return false
    }
}

const ProtectedRoutes = ({ element, allowedRoles, ...rest }) => {
    const auth = useAuth()
    const userType = localStorage.getItem('type');
    if (!auth) {
        return <Navigate to="/login" />;
    }
  {
        return (
            <div>
                <Navbar />
                <div id="content">
                    <Outlet />
                </div>
            </div>
        )
    }
  
}




export default ProtectedRoutes;
